import { Block, useBlockRenderer } from '@/hooks/use-block-renderer'
import { BlockRenderer } from '@/Components/block-renderer'
import AddressSelects from '@/Components/custom/address-selects'
import { usePage } from '@inertiajs/react'
import FlagshipStores from '@/Components/custom/flagship-stores'

export default function Stores() {
  const blocks = useBlockRenderer('stores') as Block[]
  const { flagships } = usePage().props

  return (
    <>
      <BlockRenderer blocks={blocks} />
      <FlagshipStores data={flagships} />
      <AddressSelects />
    </>
  )
}
